import React, { useEffect, useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import { Link } from "react-router-dom";

const BlogList = () => {
    const [posts, setPosts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [activeCategory, setActiveCategory] = useState("all");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(
            "https://codebuddys.in/wp-json/wp/v2/posts?_embed&per_page=100"
        )
            .then((res) => {
                if (!res.ok) throw new Error("Blog API Error");
                return res.json();
            })
            .then((data) => {
                setPosts(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Blog Fetch Error:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        fetch(
            "https://codebuddys.in/wp-json/wp/v2/categories?per_page=100"
        )
            .then((res) => {
                if (!res.ok) throw new Error("Category API Error");
                return res.json();
            })
            .then((data) => {
                const filteredCategories = data.filter(
                    (cat) => cat.slug !== "uncategorized"
                );
                setCategories(filteredCategories);
            })
            .catch((error) => {
                console.error("Category Fetch Error:", error);
            });
    }, []);

    // Proverka koi kategorii imat pone edin post, za da gi pokazvame samo tjah
    const validCategories = categories.filter((category) => {
        return posts.some((post) => {
            const terms = post._embedded?.["wp:term"] || [];
            const allCategories = terms.flat();
            return allCategories.some(
                (cat) => Number(cat.id) === Number(category.id)
            );
        });
    });

    const filteredPosts =
        activeCategory === "all"
            ? posts
            : posts.filter((post) => {
                const terms = post._embedded?.["wp:term"] || [];
                const allCategories = terms.flat();
                return allCategories.some(
                    (category) =>
                        Number(category.id) === Number(activeCategory)
                );
            });

    const getImage = (post) => {
        const featured = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
        if (featured) return featured;

        const content = post.content?.rendered || "";
        const match = content.match(/<img[^>]+src="([^">]+)"/);
        return match ? match[1] : "";
    };

    const getExcerpt = (post) => {
        const excerpt = post.excerpt?.rendered || "";
        const div = document.createElement("div");
        div.innerHTML = excerpt;
        return div.textContent || div.innerText || "";
    };

    return (
        <>
            <Header />
            <section className="blog-section">
                <div className="blog-header">
                    <h1>Our Latest Blogs</h1>
                    <p>Explore expert tutorials, insights, and tech guides crafted for developers.</p>
                </div>

                {/* Pokazvame kategorii samo ako imame obshto postove v bazata */}
                {!loading && posts.length > 0 && validCategories.length > 0 && (
                    <div className="blog-categories">
                        <button
                            type="button"
                            className={activeCategory === "all" ? "active" : ""}
                            onClick={() => setActiveCategory("all")}
                        >
                            All
                        </button>

                        {validCategories.map((category) => (
                            <button
                                type="button"
                                key={category.id}
                                className={
                                    Number(activeCategory) === Number(category.id)
                                        ? "active"
                                        : ""
                                }
                                onClick={() => setActiveCategory(category.id)}
                            >
                                {category.name}
                            </button>
                        ))}
                    </div>
                )}

                {loading && (
                    <div className="blog-loading">Loading blogs...</div>
                )}

                {!loading && filteredPosts.length === 0 && (
                    <div className="wordpress-plugin-empty-card">
                        <div className="empty-icon-wrapper">
                            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
                            </svg>
                        </div>
                        <h3>No Blogs Found!</h3>
                        <p>There are no articles available right now.</p>
                    </div>
                )}

                {!loading && filteredPosts.length > 0 && (
                    <div className="blog-grid">
                        {filteredPosts.map((post) => {
                            const image = getImage(post);
                            const excerpt = getExcerpt(post);
                            const date = new Date(post.date).toLocaleDateString("en-US", {
                                year: "numeric",
                                month: "short",
                                day: "numeric"
                            });

                            return (
                                <article className="blog-card" key={post.id}>
                                    <div className="blog-image">
                                        {image ? (
                                            <img src={image} alt={post.title?.rendered || "Blog Post"} />
                                        ) : (
                                            <div className="blog-no-image">Code Buddy Blog</div>
                                        )}
                                    </div>
                                    <div className="blog-content">
                                        <div className="blog-meta">
                                            <span className="blog-date">{date}</span>
                                        </div>
                                        <h2>
                                            <Link to={`/blog/${post.id}`}>
                                                {post.title?.rendered}
                                            </Link>
                                        </h2>
                                        <p>
                                            {excerpt ? excerpt.substring(0, 110) + "..." : "Discover deep-dive insights and development workflows on our blog."}
                                        </p>
                                        <Link to={`/blog/${post.id}`} className="blog-read-more">
                                            Read Article <span>→</span>
                                        </Link>
                                    </div>
                                </article>
                            );
                        })}
                    </div>
                )}

          
            </section>
            <Footer />
        </>
    );
};

export default BlogList;